import React from 'react';
import TriangleLogo from './TriangleLogo';
import LionLogo from './LionLogo';

/**
 * Theme-aware brand logo.
 *
 * Renders both the HFF triangle and the Rebellionaire lion; CSS classes
 * `.brand-logo-hff` / `.brand-logo-rebel` are toggled by the
 * `.theme-rebellionaire` ancestor so no prop-threading is needed.
 *
 * @param {number}  [size=48]     - Width & height in pixels.
 * @param {string}  [className]   - Extra class names forwarded to both logos.
 * @param {boolean} [light=false] - Invert to white (forwarded to TriangleLogo).
 * @param {object}  [style]       - Extra inline styles.
 */
export default function BrandLogo({ size = 48, className = '', light = false, style }) {
  return (
    <>
      <TriangleLogo
        size={size}
        className={`brand-logo-hff ${className}`}
        light={light}
        style={style}
      />
      <LionLogo
        size={size}
        className={`brand-logo-rebel ${className}`}
        style={style}
      />
    </>
  );
}
